import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c(VProgressCircular,{attrs:{"size":70,"width":7,"color":"green darken-3","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }